import { decryptToAsciiString, encryptAsciiStringToHexString } from "../dataEncryption";
const EXPLORER_STATE_OPENLIST_LOCALSTORAGE_KEY = "ExplorerDataComponent.openList";
const EXPLORER_STATE_SORT_LOCALSTORAGE_KEY = "ExplorerDataComponent.sortFilter";
const EXPLORER_STATE_FILETYPE_LOCALSTORAGE_KEY = "ExplorerDataComponent.fileTypeFilter";
const EXPLORER_STATE_TAG_LOCALSTORAGE_KEY = "ExplorerDataComponent.tagFilter";
export const loadOpenList = async (provider) => {
    const storedOpenList = sessionStorage.getItem(EXPLORER_STATE_OPENLIST_LOCALSTORAGE_KEY);
    if (storedOpenList === null) {
        return [];
    }
    else {
        const decodedOpenList = await decryptToAsciiString(provider, storedOpenList);
        const ret = decodedOpenList.split(",").map(Number);
        return ret;
    }
};
export const handleOpenList = async (provider, n, openList, setOpenList) => {
    const initialCopyOpenList = [...openList];
    let copyOpenList;
    if (openList.includes(n)) {
        copyOpenList = openList.filter((item) => item !== n);
    }
    else {
        copyOpenList = [...openList, n];
    }
    //console.log(n, "before", initialCopyOpenList, "after", copyOpenList);
    setOpenList(copyOpenList);
    sessionStorage.setItem(EXPLORER_STATE_OPENLIST_LOCALSTORAGE_KEY, await encryptAsciiStringToHexString(provider, copyOpenList.toString()));
};
export const deleteOpenList = () => {
    sessionStorage.removeItem(EXPLORER_STATE_OPENLIST_LOCALSTORAGE_KEY);
};
export const handleSortFilter = async (provider, selectedSort) => {
    if (selectedSort === undefined) {
        selectedSort = "";
    }
    sessionStorage.setItem(EXPLORER_STATE_SORT_LOCALSTORAGE_KEY, await encryptAsciiStringToHexString(provider, selectedSort));
};
export const loadSortFilter = async (provider) => {
    const storedSort = sessionStorage.getItem(EXPLORER_STATE_SORT_LOCALSTORAGE_KEY);
    if (storedSort === null) {
        return "";
    }
    else {
        const decodedSort = await decryptToAsciiString(provider, storedSort);
        return decodedSort;
    }
};
export const deleteSortFilter = async () => {
    sessionStorage.removeItem(EXPLORER_STATE_SORT_LOCALSTORAGE_KEY);
};
export const handleSelectedContentTypeFilters = async (provider, selectedContentTypeFilters) => {
    if (selectedContentTypeFilters === undefined) {
        selectedContentTypeFilters = [];
    }
    sessionStorage.setItem(EXPLORER_STATE_FILETYPE_LOCALSTORAGE_KEY, await encryptAsciiStringToHexString(provider, selectedContentTypeFilters.toString()));
};
export const loadSelectedContentTypeFilters = async (provider) => {
    const storedContentTypeList = sessionStorage.getItem(EXPLORER_STATE_FILETYPE_LOCALSTORAGE_KEY);
    if (storedContentTypeList === null) {
        return [];
    }
    else {
        const decodedContentTypeList = await decryptToAsciiString(provider, storedContentTypeList);
        if (decodedContentTypeList === "") {
            return [];
        }
        const ret = decodedContentTypeList.split(",");
        return ret;
    }
};
export const deleteSelectedContentTypeFilters = async () => {
    sessionStorage.removeItem(EXPLORER_STATE_FILETYPE_LOCALSTORAGE_KEY);
};
export const handleSelectedTagFilters = async (provider, selectedTagFilters) => {
    if (selectedTagFilters === undefined) {
        selectedTagFilters = [];
    }
    sessionStorage.setItem(EXPLORER_STATE_TAG_LOCALSTORAGE_KEY, await encryptAsciiStringToHexString(provider, selectedTagFilters.toString()));
};
export const loadSelectedTagFilters = async (provider) => {
    const storedTagList = sessionStorage.getItem(EXPLORER_STATE_TAG_LOCALSTORAGE_KEY);
    if (storedTagList === null) {
        return [];
    }
    else {
        const decodedTagList = await decryptToAsciiString(provider, storedTagList);
        if (decodedTagList === "") {
            return [];
        }
        const ret = decodedTagList.split(",");
        return ret;
    }
};
export const deleteSelectedTagFilters = async () => {
    sessionStorage.removeItem(EXPLORER_STATE_TAG_LOCALSTORAGE_KEY);
};
